import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getTimesheetApi,
  getTimeSheetListApi,
  ApproveTimesheetAPI,
  getGraphDetailsApi,
  RejectTimesheetAPI,
} from "../../API/API";

function* getTimeSheetList(action) {
  try {
    const response = yield call(() =>
      getTimeSheetListApi(action.payload.startdate, action.payload.enddate)
    ); // API Backend
    yield put({
      type: types.GET_TIMESHEET_LIST_SUCCESS,
      payload: response.data,
    });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_TIMESHEET_LIST_FAILURE, error });
  }
}

function* getTimeSheet(action) {
  try {
    const response = yield call(() =>
      getTimesheetApi(
        action.payload.userAssignmentId,
        action.payload.startdate,
        action.payload.enddate
      )
    ); // API Backend
    yield put({ type: types.GET_TIMESHEET_SUCCESS, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_TIMESHEET_FAILURE, error });
  }
}

function* approveTimesheet(action) {
  try {
    const response = yield call(() => ApproveTimesheetAPI(action.payload));
    yield put({
      type: types.APPROVE_TIMESHEET_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.APPROVE_TIMESHEET_FAILURE, error });
  }
}
function* getGraphDetails(action) {
  try {
    const response = yield call(() => getGraphDetailsApi(action.payload));
    yield put({
      type: types.GET_GRAPH_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_GRAPH_DETAILS_FAILURE, error });
  }
}
function* rejectTimesheet(action) {
  try {
    const response = yield call(() => RejectTimesheetAPI(action.payload));
    yield put({
      type: types.REJECT_TIMESHEET_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_GRAPH_DETAILS_FAILURE, error });
    yield put({ type: types.REJECT_TIMESHEET_FAILURE, error });
  }
}

export function* watchGetTimesheetListSaga() {
  yield takeEvery(types.GET_TIMESHEET_LIST_REQUESTED, getTimeSheetList);
}

export function* watchGetTimesheetSaga() {
  yield takeEvery(types.GET_TIMESHEET_REQUESTED, getTimeSheet);
}

export function* watchApproveTimesheetSaga() {
  yield takeEvery(types.APPROVE_TIMESHEET_REQUESTED, approveTimesheet);
}

export function* watchGetGraphDetailsSaga() {
  yield takeEvery(types.GET_GRAPH_DETAILS_REQUESTED, getGraphDetails);
}
export function* watchRejectTimesheetSaga() {
  yield takeEvery(types.REJECT_TIMESHEET_REQUESTED, rejectTimesheet);
}
